import clsxm from "@/lib/clsxm";
import {type FC, type PropsWithChildren} from "react";
import {Textfit} from "react-textfit";

const AutoSizeText: FC<
  {
    fontSizeMin?: number;
    fontSizeMax?: number;
    maxLines?: number;
    lineHeight?: number;
    className?: string;
    takeUpAllLineSpace?: boolean;
  } & PropsWithChildren
> = ({
  fontSizeMin = 12,
  fontSizeMax = 24,
  maxLines = 1,
  lineHeight = 1.25,
  className,
  takeUpAllLineSpace = false,
  children,
}) => {
  const height = takeUpAllLineSpace || maxLines === 1 ? maxLines * fontSizeMax * lineHeight : undefined;

  return (
    <div
      className={clsxm("flex w-full justify-start", className)}
      style={{
        maxHeight: maxLines * fontSizeMax * lineHeight,
        minHeight: fontSizeMin * lineHeight,
        height,
      }}>
      <Textfit
        className="w-full"
        style={{
          lineHeight,
          height,
        }}
        min={fontSizeMin}
        max={fontSizeMax}
        mode={maxLines > 1 ? "multi" : "single"}>
        <>{children}</>
      </Textfit>
    </div>
  );
};

export default AutoSizeText;
